var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToolDefectRca({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F00000"
    },
    d: "M256,0C114.616,0,0,114.616,0,256s114.616,256,256,256s256-114.616,256-256S397.384,0,256,0z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M320.968,424H191.032c-23.096,0-42-18.896-42-42V130c0-23.096,18.904-42,42-42h129.936c23.104,0,42,18.904,42,42v252 C362.968,405.096,344.072,424,320.968,424z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 165.44,
    y: 127.648,
    width: 183.752,
    height: 247.352
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 256,
    cy: 107.8,
    r: 7.872
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M273.808,408.424H238.2c-4.92,0-8.904-3.984-8.904-8.904s3.984-8.904,8.904-8.904h35.608 c4.92,0,8.904,3.984,8.904,8.904S278.728,408.424,273.808,408.424z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 187.232,
    y: 316.504,
    style: {
      fill: "#FFFFFF"
    },
    width: 137.528,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.496,
    y: 334.152,
    style: {
      fill: "#FFFFFF"
    },
    width: 107.016,
    height: 8
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F00000"
    },
    d: "M256,296.896l-5.704-7.536c-4.2-5.496-40.96-54.56-40.96-79.008c0-29.328,18.304-48.28,46.664-48.28 s46.664,18.952,46.664,48.28c0,24.408-36.76,73.48-40.92,79.008L256,296.896z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 255.968,
    cy: 210.672,
    r: 15.112
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolDefectRca);
export default __webpack_public_path__ + "static/media/tool_defectRca.666b4e0f37253469489f44a4fae25437.svg";
export { ForwardRef as ReactComponent };